document.addEventListener("DOMContentLoaded", function () {
  var selects = document.querySelectorAll(".se-select");

  for (var i = 0; i < selects.length; i++) {
    (function (selectEl) {
      var productId = selectEl.getAttribute("data-product");
      var form = document.querySelector('.se-product-form[data-product="' + productId + '"]');
      var hiddenInput = form ? form.querySelector('input.se-variant-id[data-product="' + productId + '"]') : null;
      var priceSpans = document.querySelectorAll('.se-custom-price[data-product="' + productId + '"]');

      if (!form || !hiddenInput) {
        console.warn("Missing select-related elements for product:", productId);
        return;
      }

      selectEl.addEventListener("change", function () {
        var selectedVariantId = this.value;
        hiddenInput.value = selectedVariantId;

        for (var j = 0; j < priceSpans.length; j++) {
          var priceSpan = priceSpans[j];
          var priceVariantId = priceSpan.getAttribute("data-variant");
          var priceProductId = priceSpan.getAttribute("data-product");

          if (priceVariantId === selectedVariantId && priceProductId === productId) {
            priceSpan.classList.add("se-custom-price-active");
          } else {
            priceSpan.classList.remove("se-custom-price-active");
          }
        }
      });
    })(selects[i]);
  }

  var buttons = document.querySelectorAll(".se-product-trigger");

  function handleAddToCart(e) {
    if (e && typeof e.preventDefault === "function") e.preventDefault();

    var productId = this.getAttribute("data-product");
    var variantInput = document.querySelector('input.se-variant-id[data-product="' + productId + '"]');
    if (!variantInput) {
      console.warn("Missing hidden variant input for product:", productId);
      return;
    }

    var variantId = variantInput.value;

    var formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);

    var xhr = new XMLHttpRequest();
    xhr.open("POST", "/cart/add.js");
    xhr.setRequestHeader("Accept", "application/json");

    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        // Add visual feedback toggle class
        var seCartToggles = document.querySelectorAll(".cart__toggle");
        for (var t = 0; t < seCartToggles.length; t++) {
          seCartToggles[t].classList.add("cart__toggle--has-items");
        }

        if (typeof window.upcartRegisterAddToCart === "function") {
          window.upcartRegisterAddToCart();
        }

        if (window.UpCart && typeof window.UpCart.showDrawer === "function") {
          window.UpCart.showDrawer();
        }

        setTimeout(function () {
          fetch("/cart.js")
            .then(function (response) {
              return response.json();
            })
            .then(function (cart) {
              var itemCount = cart.item_count;
              var countEl = document.querySelector("[data-js-cart-count]");
              if (countEl) {
                countEl.textContent = itemCount;
              }
            })
            .catch(function (error) {
              console.error("Failed to update cart count:", error);
            });
        }, 500);
      } else {
        console.error("Add to cart failed:", xhr.responseText);
      }
    };

    xhr.onerror = function () {
      console.error("Add to cart request failed");
    };

    xhr.send(formData);
  }

  for (var k = 0; k < buttons.length; k++) {
    (function (button) {
      button.addEventListener("click", handleAddToCart, true);
      button.addEventListener("mousedown", handleAddToCart);
    })(buttons[k]);
  }
});
